// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3KTRB","insightsList":"newBusinessInsightsMenu_insightsList__2Ylv7","active":"newBusinessInsightsMenu_active__3jg74"};